import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import { ContentHeader } from '../../layout/Content'
import { appContext } from '../../../App'
import InvoiceItemHeaderStyle from './css/InvoiceItemHeaderStyle'
import CustomerCreditAccountController from '../../customers_accounts/customer_credit_account/CustomerCreditAccountController'
import ReceiptItemController from '../../receipt/receiptitem/ReceiptItemController'
import ModalWindow from '../../layout/modalwindow/ModalWindow'

import { invoiceItemControllerContext } from './InvoiceItemController'
import InvoiceListController from '../invoicelist/InvoiceListController'

function InvoiceItemHeader() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const invoiceItemController = useContext(invoiceItemControllerContext)
  const { invoice, getInvoiceReceipt } = invoiceItemController

  const showMessageBoxReceiptNotFound = async () => {
    const onClick = async () => {
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      setContent(<InvoiceListController />)
    }

    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        header='Receipt Not Found'
        footer={null}
        width='25'
        height='20'>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>Receipt file/record no longer exist!</div>
          </div>
          <div className='button-container'>
            <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickSeeCreditAccount = (e) => {
    const customerCreditAccountControllerProps = {
      customerAccountId: invoice.customer_account_link.customer_account_id,
      creditAccountNumber: invoice.customer_account_link.credit_account_number
    }
    setContent(<CustomerCreditAccountController { ...customerCreditAccountControllerProps }/>)
  }

  const onClickSeeReceipt = async (e) => {
    const receipt = await getInvoiceReceipt(invoice._id)
    if (receipt) setContent(<ReceiptItemController receipt={receipt}/>)
    else showMessageBoxReceiptNotFound()
  }

  return (
    <ContentHeader>
      <div className='content-header-content'>
        <div className='header-title-caption'>
          <span style={{color: 'black'}}>{invoice.status}</span> Invoice
          &nbsp;
          {
            (invoice.status === 'Linked') &&
              <button
                onClick={onClickSeeCreditAccount}
                className='linked-button'>
                See credit account...
              </button>
          }
          {
          (invoice.status === 'Paid') &&
            <button
              id='see-receipt-link'
              onClick={onClickSeeReceipt}
              className='linked-button'>
              See receipt...
            </button>
          }
        </div>
      </div>
      <InvoiceItemHeaderStyle signed_in={app.client.signed_in}/>
    </ContentHeader>
  )
}

export default React.memo(InvoiceItemHeader)